module.exports = __webpack_public_path__ + "img/slider.28967f92.svg";